module.exports = __webpack_public_path__ + "img/電気回路_1_3_4.684f2b6b.png";